import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useI18n } from "@/i18n/i18n";
import { CalendarPlus, ChevronDown } from "lucide-react";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { googleEventUrl, outlookEventUrl, liveSessionEvent, liveIcsUrl } from "@/lib/calendarLinks";

let cachedToken = null;

export default function AddToCalendarMenu({ session, className = "" }) {
  const { t, lang } = useI18n();
  const [token, setToken] = useState(cachedToken);

  useEffect(() => {
    if (token) return;
    api.get("/calendar/sync/me").then((r) => { cachedToken = r.data.token; setToken(r.data.token); }).catch(() => {});
  }, [token]);

  const ev = liveSessionEvent(session, lang);
  const item = "flex items-center gap-2 text-sm cursor-pointer";
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          className={`inline-flex items-center justify-center gap-1.5 text-xs font-semibold rounded-full px-3 py-1.5 border border-slate-300 bg-white text-slate-700 hover:border-brand-blue hover:text-brand-blue transition-colors ${className}`}
          data-testid={`add-to-calendar-${session.id}`}
        >
          <CalendarPlus className="h-3.5 w-3.5" /> {t("add_to_calendar")} <ChevronDown className="h-3 w-3" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-[200px]">
        <DropdownMenuItem asChild>
          <a href={googleEventUrl(ev)} target="_blank" rel="noreferrer" className={item} data-testid={`cal-google-${session.id}`}>
            Google Calendar
          </a>
        </DropdownMenuItem>
        <DropdownMenuItem asChild>
          <a href={outlookEventUrl(ev)} target="_blank" rel="noreferrer" className={item} data-testid={`cal-outlook-${session.id}`}>
            Outlook
          </a>
        </DropdownMenuItem>
        {token && (
          <DropdownMenuItem asChild>
            <a href={liveIcsUrl(session.id, token)} className={item} data-testid={`cal-ics-${session.id}`}>
              Apple / {t("cal_ics_file")}
            </a>
          </DropdownMenuItem>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
